import memoize from 'lru-memoize';

import {InboxModel} from '../../../../../../../libs/shared/core/src/models/api/inboxModel';

/*
 * Helpers.
 */

export const filterInboxes = memoize(20)((inboxes: ReadonlyArray<InboxModel>, query: string) => {
  // Shortcut for empty query.
  if (!query) {
    return inboxes;
  }

  // Otherwise, filter by name.
  const lowerCaseQuery = query.toLowerCase();
  return inboxes.filter((i) => i.name.toLowerCase().includes(lowerCaseQuery));
});
